"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var messages_1 = require("./../messages");
var textOperators = [
    { text: messages_1.filterContainsOperator, operator: 'contains' },
    { text: messages_1.filterNotContainsOperator, operator: 'doesnotcontain' },
    { text: messages_1.filterEqOperator, operator: 'eq' },
    { text: messages_1.filterNotEqOperator, operator: 'neq' },
    { text: messages_1.filterStartsWithOperator, operator: 'startswith' },
    { text: messages_1.filterEndsWithOperator, operator: 'endswith' },
    { text: messages_1.filterIsNullOperator, operator: 'isnull' },
    { text: messages_1.filterIsNotNullOperator, operator: 'isnotnull' },
    { text: messages_1.filterIsEmptyOperator, operator: 'isempty' },
    { text: messages_1.filterIsNotEmptyOperator, operator: 'isnotempty' }
];
var numericOperators = [
    { text: messages_1.filterEqOperator, operator: 'eq' },
    { text: messages_1.filterNotEqOperator, operator: 'neq' },
    { text: messages_1.filterGteOperator, operator: 'gte' },
    { text: messages_1.filterGtOperator, operator: 'gt' },
    { text: messages_1.filterLteOperator, operator: 'lte' },
    { text: messages_1.filterLtOperator, operator: 'lt' },
    { text: messages_1.filterIsNullOperator, operator: 'isnull' },
    { text: messages_1.filterIsNotNullOperator, operator: 'isnotnull' }
];
var dateOperators = [
    { text: messages_1.filterEqOperator, operator: 'eq' },
    { text: messages_1.filterNotEqOperator, operator: 'neq' },
    { text: messages_1.filterAfterOrEqualOperator, operator: 'gte' },
    { text: messages_1.filterAfterOperator, operator: 'gt' },
    { text: messages_1.filterBeforeOperator, operator: 'lt' },
    { text: messages_1.filterBeforeOrEqualOperator, operator: 'lte' },
    { text: messages_1.filterIsNullOperator, operator: 'isnull' },
    { text: messages_1.filterIsNotNullOperator, operator: 'isnotnull' }
];
var booleanOperators = [
    { text: messages_1.filterEqOperator, operator: 'eq' },
    { text: messages_1.filterNotEqOperator, operator: 'neq' }
];
/**
 * Represents the operators for the TextFilter, NumericFilter, DateFilter and BooleanFilter components.
 *
 * The text field of each operator object will be resolved according to the
 * [localization messages]({% slug globalization_datatools %}#toc-messages).
 */
var Operators = /** @class */ (function () {
    function Operators() {
    }
    Object.defineProperty(Operators, "text", {
        /**
         * An array containing the operators for the TextFilter component.
         *
         * The operators are:
         *
         * - { text: 'filter.containsOperator', operator: 'contains' }
         * - { text: 'filter.notContainsOperator', operator: 'doesnotcontain' }
         * - { text: 'filter.eqOperator', operator: 'eq' }
         * - { text: 'filter.notEqOperator', operator: 'neq' }
         * - { text: 'filter.startsWithOperator', operator: 'startswith' }
         * - { text: 'filter.endsWithOperator', operator: 'endswith' }
         * - { text: 'filter.isNullOperator', operator: 'isnull' }
         * - { text: 'filter.isNotNullOperator', operator: 'isnotnull' }
         * - { text: 'filter.isEmptyOperator', operator: 'isempty' }
         * - { text: 'filter.isNotEmptyOperator', operator: 'isnotempty' }
         */
        get: function () {
            return textOperators.slice();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Operators, "numeric", {
        /**
         * An array containing the operators for the NumericFilter component.
         *
         * The operators are:
         *
         * - { text: 'filter.eqOperator', operator: 'eq' }
         * - { text: 'filter.notEqOperator', operator: 'neq' }
         * - { text: 'filter.gteOperator', operator: 'gte' }
         * - { text: 'filter.gtOperator', operator: 'gt' }
         * - { text: 'filter.lteOperator', operator: 'lte' }
         * - { text: 'filter.ltOperator', operator: 'lt' }
         * - { text: 'filter.isNullOperator', operator: 'isnull' }
         * - { text: 'filter.isNotNullOperator', operator: 'isnotnull' }
         */
        get: function () {
            return numericOperators.slice();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Operators, "date", {
        /**
         * An array containing the operators for the DateFilter component.
         *
         * The operators are:
         *
         * - { text: 'filter.eqOperator', operator: 'eq' }
         * - { text: 'filter.notEqOperator', operator: 'neq' }
         * - { text: 'filter.afterOrEqualOperator', operator: 'gte' }
         * - { text: 'filter.afterOperator', operator: 'gt' }
         * - { text: 'filter.beforeOperator', operator: 'lt' }
         * - { text: 'filter.beforeOrEqualOperator', operator: 'lte' }
         * - { text: 'filter.isNullOperator', operator: 'isnull' }
         * - { text: 'filter.isNotNullOperator', operator: 'isnotnull' }
         */
        get: function () {
            return dateOperators.slice();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Operators, "boolean", {
        /**
         * An array containing the operators for the BooleanFilter component.
         *
         * The operators are:
         *
         * - { text: 'filter.eqOperator', operator: 'eq' }
         * - { text: 'filter.notEqOperator', operator: 'neq' }
         */
        get: function () {
            return booleanOperators.slice();
        },
        enumerable: true,
        configurable: true
    });
    return Operators;
}());
exports.Operators = Operators;
/**
 * @hidden
 */
exports.stringOperator = function (operator) {
    return operator === 'contains' || operator === 'doesnotcontain' || operator === 'startswith' || operator === 'endswith';
};
/**
 * @hidden
 */
exports.unaryOperator = function (operator) {
    return operator === 'isnull' || operator === 'isnotnull' || operator === 'isempty' || operator === 'isnotempty';
};
//# sourceMappingURL=operators.js.map


//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/@progress+kendo-react-data-tools@3.18.0_bwv2g72eb344voeanxti7iyzje/~/@progress/kendo-react-data-tools/dist/npm/filter/operators.js
// module id = 168
// module chunks = 0